import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHead } from '@vueuse/head'
import SEO from '@/seo'

export function useSeo(pageName) {
    const { locale } = useI18n()

    const updateMeta = (lang) => {
        const meta = SEO[pageName][lang]

        useHead({
            title: meta.title,
            meta: [
                { name: 'description', content: meta.description },
                { name: 'keywords', content: meta.keywords },
                { property: 'og:title', content: meta.title },
                { property: 'og:description', content: meta.description },
                { property: 'og:locale', content: lang === 'ja' ? 'ja_JP' : 'ru_RU' }
            ],
            htmlAttrs: {
                lang
            }
        })
    }

    watch(locale, (lang) => updateMeta(lang), { immediate: true })
}
